import "./my-appointments.scss";

import MyAppointmentsProps, {
  Element,
  ElementDetails,
} from "./my-appointments.types";
import React, { useContext, useEffect, useReducer } from "react";
import {
  appointmentsReducer,
  initialAppointments,
} from "./reducers/appointments.reducer";
import {
  cancelAppointment,
  getMyAppointments,
} from "../../../services/coco.service";

import Button from "../../atoms/button/button";
import GlobalContext from "../../../contexts/globalContext";
import Loading from "../../atoms/loading/loading";
import { myAppointmentsAdapter } from "./adapters/myAppointments.adapter";
import swal from "sweetalert";

const MyAppointments = ({ title }: MyAppointmentsProps) => {
  const classSelector = "my-appointments";

  const [appointments, dispatch] = useReducer(
    appointmentsReducer,
    initialAppointments
  );

  const { userInfoContext }: any = useContext(GlobalContext);
  const userJwt = userInfoContext.data?.userJwt;

  const handleCancel = async (id) => {
    const areYouSure = await swal(
      "¿Estás seguro de que deseas cancelar la cita?",
      {
        buttons: ["No", "Sí"],
        icon: "info",
        dangerMode: true,
      }
    );

    if (!areYouSure || !userJwt) return;

    swal("Cancelando...", "Un momento por favor", {
      buttons: [""],
      icon: "info",
    });

    try {
      const cancelResponse = await cancelAppointment(userJwt, id);
      if (cancelResponse.data.status === 400) {
        throw "La cita no existe en BD";
      }
      await swal("¡Hecho!", "La cita ha sido cancelada", "success");
      getData();
    } catch (error) {
      swal("¡Ups!", "Hubo un error al cancelar la cita", "error");
    }
  };

  const getData = async () => {
    if (!userJwt) return;
    dispatch({ type: "LOADING" });
    try {
      const myAppointmentsResponse = await getMyAppointments(userJwt);
      if (myAppointmentsResponse.data?.data?.appointments?.length) {
        const appointmentsData = myAppointmentsAdapter(
          myAppointmentsResponse.data?.data?.appointments
        );
        dispatch({ type: "SET_APPOINTMENTS", payload: appointmentsData });
        return;
      }
      dispatch({ type: "RESET" });
    } catch (error) {
      swal("¡Ups!", "Hubo un error al consultar tus citas", "error");
      dispatch({ type: "ERROR" });
    }
  };

  useEffect(() => {
    if (!userJwt) return;
    getData();
  }, [userJwt]);

  if (!userJwt)
    return (
      <div className={classSelector}>
        <div className={`${classSelector}__container`}>
          <div className={`${classSelector}__cardsContainer`}>
            <span>🚨 Por favor inicia sesión.</span>
          </div>
        </div>
      </div>
    );

  return (
    <div className={classSelector}>
      <div className={`${classSelector}__container`}>
        <p className={`${classSelector}__small_title`}>
          Mi nutrición saludable
        </p>
        {title && <span className={`${classSelector}__title`}>{title}</span>}
        <div className={`${classSelector}__cardsContainer`}>
          {appointments.isLoading && <Loading />}

          {appointments.isError && (
            <span>
              🚨 Error al consultar tus citas, por favor intenta de nuevo más
              tarde o contacta al administrador.
            </span>
          )}

          {!appointments.appointments?.length &&
            !appointments.isLoading &&
            !appointments.isError && (
              <span className={`${classSelector}__noAppointments`}>
                ✨ Aún no tienes citas agendadas.
              </span>
            )}
          {appointments.appointments?.map((item: Element) => {
            return (
              <div key={item.id} className={`${classSelector}__card`}>
                <div className={`${classSelector}__cardInfo`}>
                  <span className={`${classSelector}__cardTitle`}>
                    {item.title}
                  </span>
                  <ul>
                    {item.details?.map((detail: ElementDetails) => {
                      return (
                        <li
                          key={detail.id}
                          className={`${classSelector}__cardItem ${
                            detail.featured
                              ? `${classSelector}__cardItem--featured`
                              : ""
                          }`}
                        >
                          {detail.icon && (
                            <i className={`${classSelector}__cardIcon`}>
                              {detail.icon}
                            </i>
                          )}
                          {detail.text && (
                            <span className={`${classSelector}__cardText`}>
                              {detail.text}
                              {detail.help && (
                                <span className={`${classSelector}__cardHelp`}>
                                  {detail.help}
                                </span>
                              )}
                            </span>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                </div>
                <div className={`${classSelector}__cardActions`}>
                  <Button
                    type="button"
                    text="Cancelar"
                    classname="secondary"
                    isDisabled={false}
                    onClickAction={() => handleCancel(item.id)}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default MyAppointments;
